'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifiedEnabled = exports.generateRandomIdentifier = exports.uuid = exports.isSignupFunnelAllowed = exports.experimentsEnabled = undefined;
exports.detectIE = detectIE;

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EXPERIMENT_BACKDOOR_PARAM = 'exp-disabled';

var experimentsEnabled = exports.experimentsEnabled = function experimentsEnabled() {
  return _QueryParamsContainer2.default.get(EXPERIMENT_BACKDOOR_PARAM) !== 'true';
};

var isSignupFunnelAllowed = exports.isSignupFunnelAllowed = function isSignupFunnelAllowed(types) {
  return types.some(function (f) {
    return f;
  });
};

var uuid = exports.uuid = function uuid() {
  var crypto = window.crypto || window.msCrypto;
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
};

var generateRandomIdentifier = exports.generateRandomIdentifier = function generateRandomIdentifier(param) {
  var paramIdentifier = param + '-exp-id';
  var random = _hubspot2.default.getItem(paramIdentifier);

  if (!random) {
    _hubspot2.default.setItem(paramIdentifier, uuid());
    random = _hubspot2.default.getItem(paramIdentifier);
  }

  return random;
};

var verifiedEnabled = exports.verifiedEnabled = function verifiedEnabled() {
  return experimentsEnabled();
};

/**
 * detect IE - https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  try {
    var userAgent = window.navigator.userAgent;


    if (!userAgent) {
      return false;
    }

    var msie = userAgent.indexOf('MSIE ');
    if (msie >= 0) {
      // IE 10 or older
      return true;
    }

    var trident = userAgent.indexOf('Trident/');
    if (trident >= 0) {
      // IE 11
      return true;
    }

    // other browser
    return false;
  } catch (e) {
    return false;
  }
}